import React, { useEffect } from 'react';
import { Background } from 'LocalGluons';
import { t } from 'Locale';
import { useStore } from 'Store';
import { Switch, Text, View } from 'react-native';
import defaultStyles from './VideoQualitySettings.jss';
import Theme from 'Theme';
import Hr from 'LocalGluons/components/Hr';
import appManager from 'AppManager';

const VideoQualitySettings = () => {
    const { dataSaverValue, setDataSaverValue } = useStore();

    const handleDataSaverOption = async () => {
        const newValue = !dataSaverValue;
        setDataSaverValue(newValue);
        await appManager.setDataSaverValueFromStorage(newValue);
    };

    const checkForData = async () => {
        const enabled = await appManager.getDataSaverValueFromStorage();
        const isEnabled = enabled.data.enableSaver;
        setDataSaverValue(isEnabled);
        return enabled;
    };

    useEffect(() => {
        checkForData();
    }, []);

    return (
        <Background>
            <Hr />
            <View style={defaultStyles.container}>
                <View style={defaultStyles.textContainer}>
                    <Text style={defaultStyles.titleStyle}>
                        {t('SETTINGS.DATA_SAVER.DATA_SAVER_TITLE')}
                    </Text>
                </View>
                <Switch
                    value={dataSaverValue}
                    onValueChange={handleDataSaverOption}
                    trackColor={{
                        true: Theme.switchTrueColor,
                        false: Theme.switchFalseColor
                    }}
                    thumbColor="#FFF"
                />
            </View>
            <Hr />
            <Text style={defaultStyles.descriptionStyle}>
                {t('SETTINGS.DATA_SAVER.DATA_SAVER_INFO_TEXT')}
            </Text>
        </Background>
    );
};

export { VideoQualitySettings };
